export const MENU_ITEMS = [
  { title: "Главная", url: "/" },
  { title: "Оценочные критерии", url: "/criteria" },
  { title: "Личный кабинет", url: "/profile" },
  { title: "О проекте", url: "/about" },
  { title: "Контакты", url: "/contacts" },
  { title: "Выход", url: "/logout" },
];

//перенесла в базу данных
//  export const TOPICS = [
//   {
//     id: 1,
//     name: "Организация снабжения",
//     questions: [
//       "Опишите виды и источники снабжения.",
//       "Охарактеризуйте способы доставки продуктов на объекты общественного питания.",
//       "Изложите правила приема и хранения сырья в объектах общественного питания.",
//       "Приведите классификацию весов по различным признакам.",
//       "Укажите требования, предъявляемые к весоизмерительным приборам.",
//       "Изложите классификацию тары по различным признакам.",
//       "Дайте определение понятию «поставка». Укажите способы поставки продуктов на объекты общественного питания, дайте им характеристику.",
//       "Опишите требования, предъявляемые к оснащению складов для хранения скоропортящихся продуктов.",
//       "Объясните, как осуществляется контроль качества сырья, поступающего на производство кондитерских изделий.",
//       "Укажите наименование инвентаря, используемого при работе кондитером.",
//     ],
//     project: {
//       name: "Создание базы данных для управления поставками сырья",
//       description:
//         "Разработать технологические карты и эскизы кондитерских изделий с использованием современных технологий или эксклюзивных видов оформления и приготовления кондитерских изделий и полуфабрикатов согласно теме проекта.",
//     },
//   },

//   {
//     id: 2,
//     name: "Подготовка сырья к производству",
//     questions: [
//       "Какое сырье применяют для приготовления кондитерских изделий?",
//       "Перечислите основные сорта пшеничной муки. Укажите от чего зависят ее хлебопекарные свойства.",
//       "Перечислите требования к качеству сахара, укажите, как влияют сахаристые вещества на структуру теста.",
//       "Расскажите о подготовке молока и молочных продуктов к производству.",
//       "Назовите виды жиров, укажите область применения в кондитерском производстве.",
//       "Назовите желирующие вещества животного и растительного происхождения. Дайте им краткую характеристику, опишите подготовку к производству.",
//       "Перечислите разновидности разрыхлителей теста.",
//       "Расскажите о подготовке к пуску в производство дрожжей. Для чего производят активацию дрожжей?",
//       "Опишите последовательность санитарной обработки яиц перед использованием в кондитерском производстве.",
//       "Укажите, какие пищевые красители применяются в кондитерском производстве.",
//       "Перечислите фрукты, используемые для изготовления кондитерских изделий, укажите особенность их подготовки в производстве.",
//     ],
//     project: {
//       name: "Разработка рецептуры нового дрожжевого изделия",
//       description:
//         "Задача проекта - создать рецептуру нового дрожжевого изделия с учетом ферментации и особенностей разных видов муки.",
//     },
//   },
//   {
//     id: 3,
//     name: "Полуфабрикаты для мучных кондитерских изделий",
//     questions: [
//       "Опишите классификацию отделочных полуфабрикатов.",
//       "Дайте определение понятию «сироп», укажите способы определения готовности сиропа.",
//       "Разъясните технологию получения инвертного сиропа. Укажите область его использования в кондитерском производстве.",
//       "Изложите технологию приготовления сиропа для промочки.",
//       "Опишите классификацию сиропов.",
//       "Опишите разновидности помады, назовите стадии технологического процесса приготовления помады сахарной.",
//       "Перечислите виды фарша и начинок в зависимости от сырья.",
//       "Дайте определение понятию «крем». Опишите классификацию кремов.",
//       "Составьте технологическую схему производства крема сливочного «Нового» с указанием основных технологических параметров производства.",
//     ],
//     project: {
//       name: "Исследование альтернативных методов приготовления бездрожжевого теста",
//       description:
//         "Проект направлен на изучение современных технологий приготовления бездрожжевого теста для диетических продуктов.",
//     },
//   },
//   {
//     id: 4,
//     name: "Дрожжевое тесто и изделия из него",
//     questions: [
//       "Назовите способы приготовления дрожжевого теста. Укажите от чего зависит способ приготовления?",
//       "Раскройте сущность безопарного способа приготовления теста.",
//       "Опишите технологический процесс приготовления дрожжевого безопарного теста в виде схемы, с указанием технологических параметров производства.",
//       "Укажите внешние признаки окончания замеса теста.",
//       "Перечислите факторы, влияющие на продолжительность брожения. Укажите внешние признаки окончания процесса брожения теста.",
//       "Опишите назначение процесса обминки. Укажите от чего зависит количество обминок в тесте?",
//       "Перечислите стадии процесса разделки изделий из дрожжевого теста. Укажите назначение расстойки изделия.",
//       "Опишите технологический процесс приготовления дрожжевого опарного теста в виде схемы, с указанием технологических параметров производства.",
//       "Опишите технологический процесс приготовления ромовых баб и кексов.",
//       "Дайте определение изделию, изображенному на иллюстрации.",
//       "Дайте характеристику режимам выпечки. Назовите факторы, влияющие на время выпечки.",
//       "Перечислите сырье, входящее в опару. Укажите внешние признаки готовности опары.",

//       "Укажите ассортимент изделий из дрожжевого теста.",
//       "Опишите технологический процесс приготовления дрожжевого слоеного теста.",
//     ],
//     project: {
//       name: "Создание новой линии отделочных полуфабрикатов для тортов",
//       description:
//         "Проект по разработке новых вкусов и текстур для отделочных полуфабрикатов, ориентированных на высокие стандарты кондитерского искусства.",
//     },
//   },
//   {
//     id: 5,
//     name: "Бездрожжевое тесто и изделия из него",
//     questions: [
//       "Перечислите виды бездрожжевого теста.",
//       "Назовите способы разрыхления бездрожжевого теста.",
//       "Охарактеризуйте сырье для приготовления заварного теста.",
//       "Каковы особенности выпечки заварного полуфабриката.",
//       "Охарактеризуйте ассортимент изделий из заварного теста.",
//       "Опишите технологию производства песочного полуфабриката в виде схемы, с указанием технологических параметров производства.",
//       "Назовите причины дефектов изделий из песочного теста и способы их устранения.",
//       "Назовите основные способы приготовления бисквитного полуфабриката.",
//       "Опишите технологический процесс приготовления бисквитного теста с подогревом.",
//       "Опишите особенности приготовления масляного бисквита.",
//       "Укажите ассортимент изделий из бисквитного теста.",
//       "Назовите виды и причины брака бисквитного полуфабриката.",
//       "Перечислите способы изготовления пряничного теста.",
//       "Охарактеризуйте ассортимент изделий из слоеного пресного теста.",
//       "Назовите виды и причины брака слоеного полуфабриката.",
//       "Перечислите все известные Вам способы увеличения эффективности взбивания белковой массы.",
//       "Укажите известные Вам особенности выпечки воздушного полуфабриката.",
//     ],
//     project: {
//       name: "Запуск линии мини-пирожных",
//       description:
//         "Проект нацелен на разработку технологической линии для массового производства мини-пирожных с минимальными затратами и максимальной производительностью.",
//     },
//   },
//   {
//     id: 6,
//     name: "Отделочные полуфабрикаты для пирожных и тортов",
//     questions: [
//       "Какой процесс называется темперированием шоколада?",
//       "Перечислите виды отделочных полуфабрикатов, укажите их назначение.",
//       "Назовите виды глазури и технологии их приготовления.",
//       "Опишите технологию приготовления мастики, укажите ее разновидности.",
//       "Опишите технологию приготовления желе, перечислите ассортимент желе.",
//       "Перечислите разновидности посыпок, используемых для обсыпки кондитерских изделий.",
//       "Приведите классификацию кремов, в зависимости от рецептуры и технологии приготовления.",
//       "Дайте характеристику белковым кремам.",
//       "Укажите отличительные особенности карамели ливной, атласной, пластичной.",
//       "Определите вид отделочного полуфабриката, который используется при приготовлении торта, изображенного на иллюстрации. Опишите технологию приготовления данного вида отделки.",
//       "Опишите технологию приготовления крема зефир в виде схемы, с указанием технологических параметров производства.",
//     ],
//     project: {
//       name: "Создание ассортимента шоколадных изделий ручной работы",
//       description:
//         "Проект по разработке линейки шоколадных изделий ручной работы с использованием техники темперирования для улучшения качества.",
//     },
//   },
//   {
//     id: 7,
//     name: "Приготовление пирожных",
//     questions: [
//       "Дайте определение понятию «пирожное», опишите классификацию пирожных в зависимости от выпеченного полуфабриката.",
//       "Изложите общий алгоритм приготовления бисквитных пирожных в виде схемы.",
//       "Укажите ассортимент бисквитных пирожных, сроки годности с различными кремами.",
//       "Опишите алгоритм приготовления песочных пирожных.",
//       "Укажите ассортимент песочных пирожных.",
//       "Опишите особенности приготовления заварных пирожных.",
//       "Укажите ассортимент заварных пирожных.",
//       "Опишите разновидности птифуров и укажите их отличие от пирожных массового изготовления.",
//       "Охарактеризуйте особенности приготовления слоеных пирожных.",
//       "Укажите, какие крема используют для приготовления воздушных пирожных. Ответ обоснуйте.",
//       "Укажите особенность комбинированных пирожных.",
//       "Опишите технологию приготовления основы для крошковых пирожных.",
//     ],
//     project: {
//       name: "Разработка новых кремовых десертов с низким содержанием сахара",
//       description:
//         "Проект по созданию кремовых десертов для людей, следящих за потреблением сахара, без ущерба для вкуса.",
//     },
//   },
//   {
//     id: 8,
//     name: "Приготовление тортов",
//     questions: [
//       "Опишите классификацию тортов по различным признакам.",
//       "Перечислите особенности фигурных тортов.",
//       "Изложите алгоритм приготовления тортов бисквитных массового производства.",
//       "Назовите стандартные размеры 0,5 кг и 1 кг круглого торта.",
//       "Назовите основные этапы приготовления песочных тортов. Укажите ассортимент.",
//       "Назовите особенности отделки бисквитного торта «Прага».",
//       "Опишите технологию приготовления торта «Подарочного».",
//       "Назовите допустимые отклонения по массе различных тортов.",
//       "Перечислите основные полуфабрикаты торта «Минчанка», укажите условия и сроки хранения.",
//       "Назовите ассортимент комбинированных тортов, укажите основные полуфабрикаты, входящие в их состав.",
//       "Перечислите основные принципы создания муссового торта и назовите его составляющие.",
//       "Предложите варианты финишного покрытия и вкусовых сочетаний для приготовления муссового торта.",
//     ],
//     project: {
//       name: "Исследование влияния температуры на текстуру замороженных десертов",
//       description:
//         "Проект включает изучение влияния разных методов заморозки на текстуру мороженого и других замороженных десертов.",
//     },
//   },
//   {
//     id: 9,
//     name: "Приготовление десертов",
//     questions: [
//       "Изложите классификацию десертов, укажите температуру их подачи.",
//       "Предложите ассортимент и технологию приготовления холодных десертов.",
//       "Предложите ассортимент и технологию приготовления горячих десертов.",
//       "Опишите особенности приготовления пудингов.",
//       "Назовите сыры, из которых приготавливают полуфабрикат для чизкейков.",
//       "Перечислите низкотемпературные десерты, укажите их отличительные особенности.",
//     ],
//     project: {
//       name: "Создание уникальных рецептур начинок для премиум тортов",
//       description:
//         "Проект включает разработку новых рецептур начинок с использованием редких ингредиентов и современных методов обработки.",
//     },
//   },
//   {
//     id: 10,
//     name: "Приготовление национальных кондитерских изделий",
//     questions: [
//       "Назовите отличительные особенности восточных кондитерских изделий.",
//       "Перечислите восточные изделия, которые приготавливают из дрожжевого теста.",
//       "Назовите технологию приготовления национальных мучных кондитерских изделий из бездрожжевого теста.",
//       "Назовите вкусовые ароматические вещества, которые используются для приготовления восточных кондитерских изделий.",
//       "Опишите особенности приготовления европейских тортов.",
//     ],
//     project: {
//       name: "Разработка технологии автоматического украшения выпечки",
//       description:
//         "Проект нацелен на создание автоматизированной линии по украшению кондитерских изделий для увеличения скорости и точности на производстве.",
//     },
//   },
// ];
